<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
    },
    data() {
        return {
            catalogue: new Catalogue(),
            date_time:'',
            errors: {},
            form: {
                taxes: [],
                min: [],
                max: [],
                quotas: [],
                percentages: [],
            },
            send: false,
        }
    },
    methods: {
        closedModal() {
            this.form.id = '';
            this.date_time = '';
            this.form.taxes = [];
            this.form.min = [];
            this.form.max = [];
            this.form.quotas = [];
            this.form.percentages = [];
            this.catalogue.share_taxes = [];
            this.send = false;
            this.errors = {};
            this.$modal.hide('editTaxes');
        },
        updateTaxes() {
            let vm=this;
            this.form.taxes=this.catalogue.share_taxes.map(a=> a.id);
            this.catalogue.share_taxes.forEach(function(tax){
                vm.form.min['id_'+tax.id]=tax.min;
                vm.form.max['id_'+tax.id]=tax.max??0;
                vm.form.quotas['id_'+tax.id]=tax.quota;
                vm.form.percentages['id_'+tax.id]=Math.round((tax.percentage??0)*10000)/100;
            });
            this.date_time=new Date(Math.max(...this.catalogue.share_taxes.map(e => new Date(e.updated_at)))).toLocaleString().replace('T', ' ').slice(0, 19);
        },
        async saveTaxes() {
            this.send = true;
            const data_form = new FormData();
            const taxesArray = this.form.taxes.map(id => ({
                id,
                min: this.form.min['id_' + id] || 0,
                max: this.form.max['id_' + id] || null,
                quota: this.form.quotas['id_' + id] || 0,
                percentage: this.form.percentages['id_' + id] || 0,
            }));

            data_form.append('taxes', JSON.stringify(taxesArray));

            let _endpoint = '/partners/taxes';
            try {
                let { data } = await request.post(_endpoint, data_form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                }
                this.errors = {};
                this.send = false;
            } catch (error) {
                this.send = false;
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    watch: {
        'catalogue.share_taxes'() {
            this.updateTaxes();
        }
    },
    mounted() {
        // this.catalogue.get_share_taxes();
    },
    created() {
        Event.$on("event-show-editTaxes", async () => {
            this.catalogue.get_share_taxes();
            this.$modal.show('editTaxes');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
}
</script>
<template>
    <modal name="editTaxes" :width="'80%'" :maxHeight="300" :height="'auto'" v-bind:click-to-close="false">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveTaxes" method="post">
            <button :disabled="send" type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                    class="fa-solid fa-xmark"></i> </button>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Tarifas Calculadas</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 mt-3">
                        <h3 class="card-title"><strong>Último Cambio</strong> {{ date_time | toDateTimeHour }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-3">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Límite inferior</th>
                                    <th>Límite superior</th>
                                    <th>Cuota fija</th>
                                    <th>Tasa excedente</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(tax, index_tax) in catalogue.share_taxes" :key="index_tax">
                                    <td>
                                        <money class="form-control" v-model="form.min['id_' + tax.id]"
                                        :id="'min-' + tax.id"></money>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="form.max['id_' + tax.id]"
                                            :disabled="!prop_edit || (tax.max??0)==0"
                                            :id="'max-' + tax.id"></money>
                                    </td>
                                    <td>
                                        <money class="form-control" v-model="form.quotas['id_' + tax.id]"
                                        :id="'quotas-' + tax.id"></money>
                                    </td>
                                    <td>
                                        <input type="number" class="form-control" v-model="form.percentages['id_' + tax.id]"
                                            :id="'percentages-' + tax.id" step="0.01" min="0.01">
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                        <div class="text-info">El l&iacute;mite superior de la &uacute;ltima tarifa siempre se tiene que dejar en 0</div>
                        <div v-if="errors && errors.taxes" class="text-danger">{{ errors.taxes[0] }}</div>
                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button :disabled="send" type="submit"
                            class="btn float-right btn-outline-success">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" :disabled="send" @click="closedModal()"
                            class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.image-upload>input {
    display: none;
}

.del {
    position: absolute;
    right: 0px;
    margin: 10px;
}
</style>